import { KATANA_SETTLEMENT_TOKEN } from "@cede/utils";

/**
 * Translate hub-v2 perps pair symbols to Katana market symbols.
 * Hub-v2 form: `BASE/QUOTE:settle` (e.g. `ETH/USD:VBUSDC`).
 * Katana form: `BASE-QUOTE` (e.g. `ETH-USD`).
 */
export function formatKatanaSymbol(pairSymbol: string): string {
  const base = pairSymbol.split(":")[0] ?? pairSymbol;
  return base.replace("/", "-");
}

/**
 * Normalize any hub-v2 Katana pair symbol to the canonical CCXT market symbol
 * `BASE/QUOTE:VBUSDC`. Strips whatever settle suffix the upstream selection
 * carries (a stale `:USD`, or none at all) and re-attaches the protocol
 * settlement token, so the result always matches the SDK market key built in
 * `parseMarketRow`. Both sides read `KATANA_SETTLEMENT_TOKEN` from `@cede/utils`,
 * so they cannot drift.
 */
export function toKatanaMarketSymbol(pairSymbol: string): string {
  const basePair = pairSymbol.split(":")[0] ?? pairSymbol;
  return `${basePair}:${KATANA_SETTLEMENT_TOKEN}`;
}
